// Paesi più comuni nel Taekwondo Olimpico — ISO 3166-1
// alpha3: codice IOC/ISO alpha-3 | alpha2: codice ISO alpha-2 per bandiera emoji

export const TKD_COUNTRIES = [
  { alpha3: 'KOR', alpha2: 'KR', name: 'Corea del Sud' },
  { alpha3: 'ITA', alpha2: 'IT', name: 'Italia' },
  { alpha3: 'FRA', alpha2: 'FR', name: 'Francia' },
  { alpha3: 'GBR', alpha2: 'GB', name: 'Gran Bretagna' },
  { alpha3: 'USA', alpha2: 'US', name: 'Stati Uniti' },
  { alpha3: 'JPN', alpha2: 'JP', name: 'Giappone' },
  { alpha3: 'CHN', alpha2: 'CN', name: 'Cina' },
  { alpha3: 'TUR', alpha2: 'TR', name: 'Turchia' },
  { alpha3: 'IRN', alpha2: 'IR', name: 'Iran' },
  { alpha3: 'ESP', alpha2: 'ES', name: 'Spagna' },
  { alpha3: 'GER', alpha2: 'DE', name: 'Germania' },
  { alpha3: 'RUS', alpha2: 'RU', name: 'Russia' },
  { alpha3: 'MEX', alpha2: 'MX', name: 'Messico' },
  { alpha3: 'BRA', alpha2: 'BR', name: 'Brasile' },
  { alpha3: 'UZB', alpha2: 'UZ', name: 'Uzbekistan' },
  { alpha3: 'THA', alpha2: 'TH', name: 'Thailandia' },
  { alpha3: 'CIV', alpha2: 'CI', name: "Costa d'Avorio" },
  { alpha3: 'GRE', alpha2: 'GR', name: 'Grecia' },
  { alpha3: 'MGL', alpha2: 'MN', name: 'Mongolia' },
  { alpha3: 'TPE', alpha2: 'TW', name: 'Taipei Cinese' },
  { alpha3: 'AZE', alpha2: 'AZ', name: 'Azerbaigian' },
  { alpha3: 'KAZ', alpha2: 'KZ', name: 'Kazakistan' },
  { alpha3: 'ARG', alpha2: 'AR', name: 'Argentina' },
  { alpha3: 'EGY', alpha2: 'EG', name: 'Egitto' },
  { alpha3: 'MAR', alpha2: 'MA', name: 'Marocco' },
  { alpha3: 'NGR', alpha2: 'NG', name: 'Nigeria' },
  { alpha3: 'SRB', alpha2: 'RS', name: 'Serbia' },
  { alpha3: 'CRO', alpha2: 'HR', name: 'Croazia' },
  { alpha3: 'AUS', alpha2: 'AU', name: 'Australia' },
  { alpha3: 'NZL', alpha2: 'NZ', name: 'Nuova Zelanda' },
  { alpha3: 'INA', alpha2: 'ID', name: 'Indonesia' },
  { alpha3: 'PHI', alpha2: 'PH', name: 'Filippine' },
  { alpha3: 'VIE', alpha2: 'VN', name: 'Vietnam' },
  { alpha3: 'COL', alpha2: 'CO', name: 'Colombia' },
  { alpha3: 'VEN', alpha2: 'VE', name: 'Venezuela' },
  { alpha3: 'CUB', alpha2: 'CU', name: 'Cuba' },
  { alpha3: 'DOM', alpha2: 'DO', name: 'Rep. Dominicana' },
  { alpha3: 'SLO', alpha2: 'SI', name: 'Slovenia' },
  { alpha3: 'BEL', alpha2: 'BE', name: 'Belgio' },
  { alpha3: 'NED', alpha2: 'NL', name: 'Paesi Bassi' },
  { alpha3: 'POL', alpha2: 'PL', name: 'Polonia' },
  { alpha3: 'HUN', alpha2: 'HU', name: 'Ungheria' },
  { alpha3: 'GEO', alpha2: 'GE', name: 'Georgia' },
  { alpha3: 'ARM', alpha2: 'AM', name: 'Armenia' },
  { alpha3: 'PRK', alpha2: 'KP', name: 'Corea del Nord' },
  { alpha3: 'JOR', alpha2: 'JO', name: 'Giordania' },
  { alpha3: 'DEN', alpha2: 'DK', name: 'Danimarca' },
  { alpha3: 'SWE', alpha2: 'SE', name: 'Svezia' },
  { alpha3: 'NOR', alpha2: 'NO', name: 'Norvegia' },
  { alpha3: 'CAN', alpha2: 'CA', name: 'Canada' },
  { alpha3: 'ROU', alpha2: 'RO', name: 'Romania' },
];

/**
 * Converte un codice ISO alpha-2 in bandiera emoji
 * Es. 'IT' → '🇮🇹'
 */
export function getFlagEmoji(alpha2) {
  if (!alpha2 || alpha2.length !== 2) return '';
  const base = 0x1F1E6 - 65; // 65 = 'A'.charCodeAt(0)
  return String.fromCodePoint(
    base + alpha2.toUpperCase().charCodeAt(0),
    base + alpha2.toUpperCase().charCodeAt(1)
  );
}

/**
 * Restituisce bandiera + codice dato un alpha3
 * Es. 'ITA' → '🇮🇹 ITA'
 */
export function getFlagByAlpha3(alpha3) {
  if (!alpha3) return '';
  const country = TKD_COUNTRIES.find(c => c.alpha3.toUpperCase() === alpha3.toUpperCase());
  if (!country) return alpha3;
  return getFlagEmoji(country.alpha2) + ' ' + country.alpha3;
}

/**
 * Filtra i paesi per codice alpha3 o nome (case-insensitive)
 */
export function searchCountries(query) {
  if (!query || query.length < 1) return [];
  const q = query.toUpperCase();
  return TKD_COUNTRIES.filter(c =>
    c.alpha3.toUpperCase().startsWith(q) ||
    c.name.toUpperCase().includes(query.toLowerCase().toUpperCase())
  ).slice(0, 6);
}
